import '../../styles/common/footer.css';
import { getIcon } from '../../utils/iconUtils.js';
import logoVariant from '../../assets/icons/logo-variant.svg'

function Footer() {

    // Para qualquer tipo de dado do footer alterar conforme necessario
    //Tanto ícones quanto dados necessarios

    const mockFooterData = {
        contato: {
            titulo: "Entre em contato",
            itens: [
                { icone: "telefone", texto: "Matriz 0800 009 4444" },
                { icone: "telefone", texto: "Matriz (49) 3644-4444" },
                { icone: "telefone", texto: "Filial SAS (46) 3563-3000" },
            ],
        },
        midia: {
            titulo: "Nossas redes",
            itens: [
                { icone: "facebook", texto: "https://www.facebook.com/nettri.oficial?mibextid=ZbWKwL" },
                { icone: "instagram", texto: "https://www.instagram.com/nettri.oficial?igsh=dnAzcXYxeXNna29v" },
            ],
        },
        localidade: {
            titulo: "Onde atuamos",
            cidades: [
                { nome: "Barracão - PR" },
                { nome: "Dionísio Cerqueira - SC" },
                { nome: "Bom Jesus do Sul - PR" },
                { nome: "Flor da Serra do Sul - PR" },
                { nome: "Pranchita - PR" },
                { nome: "Santo Antônio do Sudoeste - PR" },
            ],
        },
    };

    const contactItems = mockFooterData.contato.itens.map((item, index) => {
        const Icon = getIcon(item.icone, 'contatoIcon');
        return (
            <div key={index} className="contact-item">
                <Icon />
                <p>{item.texto}</p>
            </div>
        );
    });

    const mediaItems = mockFooterData.midia.itens.map((item, index) => {
        const Icon = getIcon(item.icone, 'mediaIcon');
        return (
            <a key={index} href={item.texto} target="_blank" rel="noopener noreferrer" className="media-item">
                <Icon />
            </a>
        );
    });

    const cities = mockFooterData.localidade.cidades.map((cidade, index) => (
        <p key={index}>{cidade.nome}</p>
    ));

    return (
        <footer id="Contact">
            <div className="Contatos">
                <h2>{mockFooterData.contato.titulo}</h2>
                {contactItems}
            </div>

            <div className="Midias">
                <h2>{mockFooterData.midia.titulo}</h2>
                <img src={logoVariant} alt="logo-2"></img>
                <div className="Redes">{mediaItems}</div>
            </div>

            <div className="Localidades">
                <h2>{mockFooterData.localidade.titulo}</h2>
                <div className="Cidades">{cities}</div>
            </div>
        </footer>
    );
}

export default Footer;
